import React from "react"

import { useTranslations } from "@cirrus/core/i18n/provider"
import { Button } from "@cirrus/ui-kit-ts/src/components/atoms/Button"

import { useCustomerInfo } from "../../../CustomerInfo"
import { ButtonLoginWithSaml } from "../../components/ButtonLoginWithSaml"
import { AlternativeLoginButtons } from "../../containers/AlternativeLoginButtons"
import { useNavigationService } from "../../providers/NavigationService"

const LOGIN_WITH_KEYCODE_BTN_ID = "login-with-keycode-btn-id"

export const AlternativeLoginForPassword = () => {
  const { navigate } = useNavigationService()
  const { i18n } = useTranslations()
  const customerInfo = useCustomerInfo()

  return <AlternativeLoginButtons>
    {customerInfo.data?.saml?.enabled && <ButtonLoginWithSaml/>}

    {!!customerInfo.data?.keycode && <Button type="button"
                                             label={`${i18n("Account.Login:LoginWith")} ${i18n("Account.Login:Keycode")}`}
                                             id={LOGIN_WITH_KEYCODE_BTN_ID}
                                             variant="outlined" onClick={() => navigate("/keycode")}/>}
  </AlternativeLoginButtons>
}
